import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';

export function Login({ onLogin }: { onLogin: () => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await api('/auth/login', { method: 'POST', json: { email, password } });
      onLogin();
    } catch (err) {
      setError((err as Error).message || 'Login failed');
      setSubmitting(false);
    }
  }

  return (
    <div className="login-page">
      <div className="card login-card">
        <h1>Admin sign in</h1>
        <p className="muted small">Dealer Bosses control panel</p>
        <form onSubmit={handleSubmit} autoComplete="off">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={submitting}
          />
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            disabled={submitting}
          />
          {error && <div className="banner err" style={{ marginTop: 12 }}>{error}</div>}
          <div className="button-row">
            <button type="submit" disabled={submitting}>
              {submitting ? 'Signing in…' : 'Sign in'}
            </button>
          </div>
          <div style={{ marginTop: 16, fontSize: 13 }}>
            <Link to="/forgot">Forgot your password?</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
